import { Chart } from 'highcharts';

export const exportDataToCsv = (chart?: Chart | null): void => {
  chart?.downloadCSV();
};

export const exportDataToXls = (chart?: Chart | null): void => {
  chart?.downloadXLS();
};
